<template>
  <div>
    <ValidationObserver ref="observer" style="position: absolute;">
      <v-row no-gutters align="center">
        <v-col cols="12" sm="12" md="6" class="pt-8">
          <modal-cadu :close="close" :width="800" v-model="show">
            <div slot="all" class="py-10 px-10">
              <div slot="header">
                <div
                  class="font-primaria headline font-weight-bold pb-4"
                  style="color: #00995D"
                >{{actionName}} PREMIAÇÃO</div>
              </div>
              <div slot="body" class="body-line">
                <v-row>
                  <v-col cols="12" sm="12" md="9">
                    <validation-provider
                      name="nomeSeloCertificacao"
                      mode="eager"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <input-cadu
                        :errorMessage="errors[0]"
                        title="Nome da Premiação"
                        :disabled="!canEdit()"
                        v-model="objPremiacao.nome"
                        :colorText="$vuetify.theme.themes.light.fontColor1"
                        :max="'50'"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="9">
                    <validation-provider
                      name="instituicaoResponsavel"
                      mode="eager"
                      rules="required|max:50"
                      v-slot="{ errors }"
                    >
                      <input-cadu
                        :errorMessage="errors[0]"
                        title="Instituição Responsável"
                        :disabled="!canEdit()"
                        v-model="objPremiacao.institutoResponsavel"
                        :colorText="$vuetify.theme.themes.light.fontColor1"
                        :max="'50'"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="5">
                    <datepicker-cadu
                      :validateProviderRules="'required|dateValidatorForPass'"
                      :inputTitle="'Data da Premiação'"
                      :inputValue="objPremiacao.dataPremiacao"
                      :disabled="!canEdit()"
                      @value="value => objPremiacao.dataPremiacao = value"
                      typeCalendar="date"
                      width="280"
                    ></datepicker-cadu>
                  </v-col>
                </v-row>
              </div>
              <div slot="footer" class="pt-06">
                <div v-if="!$vuetify.breakpoint.xs">
                  <div v-if="!canEdit()">
                    <v-row align="end" justify="end">
                      <v-col cols="auto">
                        <button-cadu @click="show = false">
                          <div>VOLTAR</div>
                        </button-cadu>
                      </v-col>
                    </v-row>
                  </div>
                  <div v-else class="pt-8">
                    <v-row align="start" justify="start">
                      <v-col cols="auto" v-if="action === 'add'">
                        <button-cadu outline @click="show = false">VOLTAR</button-cadu>
                      </v-col>
                      <v-col cols="auto" v-if="action === 'edit'">
                        <button-cadu outline @click="verifyCancelar">CANCELAR</button-cadu>
                      </v-col>
                      <v-row align="end" justify="end" class="mr-2 mt-2">
                        <v-col cols="5" v-if="action === 'add'">
                          <button-cadu
                            :backColor="$vuetify.theme.themes.light.primary2"
                            block
                            @click="confirmar(objPremiacao,false)"
                          >SALVAR E ADICIONAR OUTRO</button-cadu>
                        </v-col>
                        <v-col cols="3">
                          <button-cadu @click="confirmar(objPremiacao,true)">SALVAR</button-cadu>
                        </v-col>
                      </v-row>
                    </v-row>
                  </div>
                </div>
                <div v-else>
                  <div v-if="canEdit()" class="pt-8">
                    <v-row align="start" justify="start">
                      <v-row :class="$vuetify.breakpoint.xs ? '' : 'mr-2 mt-2'">
                        <v-col cols="12">
                          <button-cadu block @click="confirmar(objPremiacao)">SALVAR</button-cadu>
                        </v-col>
                        <v-col cols="12" v-if="action === 'add'">
                          <button-cadu block @click="confirmar(objPremiacao)">VOLTAR</button-cadu>
                        </v-col>
                      </v-row>
                      <v-col cols="12" v-if="action === 'edit'">
                        <button-cadu outline block @click="verifyCancelar">CANCELAR</button-cadu>
                      </v-col>
                    </v-row>
                  </div>
                  <div v-if="!canEdit()">
                    <v-row align="end" justify="end">
                      <v-col cols="12">
                        <button-cadu block @click="show = false">
                          <div>VOLTAR</div>
                        </button-cadu>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
            </div>
          </modal-cadu>
        </v-col>
      </v-row>
    </ValidationObserver>
    <modal-cancelar v-model="showModalCancelar" @cancelar-edicao="cancelarEdicao()" />
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import { cloneDeep, isEqual, assign } from 'lodash'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  directives: {
    mask
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    premiacao: {
      type: Object,
      required: false
    },
    action: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      close: true,
      show: this.value,
      switchAtivo: false,
      objPremiacao: {
        nome: '',
        dataPremiacao: '',
        institutoResponsavel: ''
      },
      cloneObjPremiaco: {},
      listaInsituicoes: [],
      listaCertificadoSelo: [],
      tokenBearer: localStorage.getItem('tokenBearer'),
      showModalCancelar: false
    }
  },

  methods: {
    cancelarEdicao () {
      // let obj = {};
      // assign(obj, this.cloneObjPremiaco);
      // this.objPremiacao = obj;
      this.showModalCancelar = false;
      this.$emit('input', false);
    },
    verifyCancelar () {
      if (!isEqual(this.cloneObjPremiaco, this.objPremiacao)) {
        this.showModalCancelar = true;
      } else {
        this.showModalCancelar = false;
        this.$emit('input', false);
      }
    },
    async confirmar (objeto, salvar) {
      let responseValidate = await this.$refs.observer.validate()
      if (responseValidate) {
        if (salvar) {
          this.$emit('salvar', objeto)
        } else {
          this.$emit('finalizar-criar', objeto)
        }
      }
    },

    canEdit () {
      if (this.action === 'view') {
        return false
      } else {
        return true
      }
    },

    cleanObjeto () {
      this.objPremiacao = {}
    }
  },
  computed: {
    actionName () {
      switch (this.action) {
        case 'view':
          return 'VISUALIZAR'
        case 'edit':
          return 'EDITAR'
        case 'add':
          return 'ADICIONAR'
        default:
          return ''
      }
    }
  },

  watch: {
    show () {
      if (!this.show) {
        this.$emit('input', false)
        this.cleanObjeto()
      }
    },
    value () {
      this.show = this.value
    },
    premiacao () {
      this.objPremiacao = this.premiacao
      this.cloneObjPremiaco = cloneDeep(this.objPremiacao)
    }
  }
}
</script>

<style>
</style>
